function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnscheduledTask = function SvgUnscheduledTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Unscheduled box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 1510",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.59 730.058V740a1.541 1.541 0 0 1-.443 1.082 1.5 1.5 0 0 1-1.068.447H585.51a1.5 1.5 0 0 1-1.068-.447A1.541 1.541 0 0 1 584 740v-9.939a1.541 1.541 0 0 1 .443-1.082 1.5 1.5 0 0 1 1.068-.447h.754V727h1.51v1.529h6.04V727h1.51v1.529h.754a1.5 1.5 0 0 1 1.068.447 1.541 1.541 0 0 1 .443 1.082zm-1.511 1.529H585.51V740h10.569z",
    "data-name": "Path 11293",
    style: {
      fill: "#fff"
    },
    transform: "translate(-579.812 -723.263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 4.892 2.018-2.013L0 .867.871 0l2.016 2.012L4.9 0l.869.867-2.013 2.012L5.77 4.887l-.87.867-2.013-2.009L.869 5.759z",
    "data-name": "Union 5",
    style: {
      fill: "#fff"
    },
    transform: "translate(8.098 9.548)"
  }))));
};
export default SvgUnscheduledTask;